import React, {Suspense, useEffect, useState} from 'react';
import { Provider, useSelector, useDispatch } from 'react-redux';
import {
	Router,
	Route
} from 'react-router-dom';
import history from './history';
import store from './store';
import AppContext from './AppContext';
import SusLoading from '../component/common/Loader';
import Loader from '../app/Loader';
import Header from '../page/app/Header';
import { FormattedHTMLMessage, IntlProvider } from 'react-intl';
import styles from './style.module.scss';
import { RDX_APP_GEN_DSP_AMTOKEN } from '../redux/appAction';
import { Paragraph, Button } from '@piggybank/core';
import { shared } from '../common/config/sharedConstants';
import Drawer from '@mui/material/Drawer';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

const drawerWidth = 288;

const Main = styled('Main', { shouldForwardProp: (prop) => prop !== 'open' })(
	({ theme, open }) => ({
		flexGrow: 1,
		padding: theme.spacing(3),
		transition: theme.transitions.create('margin', {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen
		}),
		...(open && {
			transition: theme.transitions.create('margin', {
				easing: theme.transitions.easing.easeOut,
				duration: theme.transitions.duration.enteringScreen

			}),
			width: `calc(100% - ${drawerWidth}px)`,
			marginLeft: drawerWidth
		})
	})
);

const StyledHeader = styled('div', {
	shouldForwardProp: (prop) => prop !== 'open'
})(({ theme, open }) => ({
	zIndex: theme.zIndex.drawer + 1,
	transition: theme.transitions.create(['width', 'margin'], {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen
	}),
	...(open && {
		transition: theme.transitions.create(['width', 'margin'], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),
		marginLeft: drawerWidth,
		width: `calc(100% - ${drawerWidth}px)`
	})
}));

function IntlControllor() {
	const headerData = shared.header;

	const dispatch = useDispatch();
	const localeIntl = useSelector(state => state.session.localeIntl);
	const language = useSelector(state => state.intl);
	const apiInflight = useSelector(state => state.app.apiInflight);
	const [open, setOpen] = useState(false);


	const isMenuOpen = () => {
		setOpen(!open);
	};

	const toggleDrawer = (newOpen) => () => {
		setOpen(newOpen);
	};

	const navToPib = () => {
		window.location.href = process.env.REACT_APP_GSP_DASHBOARD_PAGE_LIN;
	};

	const sessionContext =
	{
		'contextId': 'NA'
	};

	const SuspenseLoading = <SusLoading />;

	const DrawerHeader = styled('div')(({ theme }) => ({
		display: 'flex',
		alignItems: 'center',
		padding: theme.spacing(0, 1),
		// necessary for content to be below app bar
		...theme.mixins.toolbar,
		justifyContent: 'flex-end'
	}));

	useEffect(
		() => {
			setInterval(() => {
				dispatch({ type: RDX_APP_GEN_DSP_AMTOKEN, 'isNavigate': false });
			}, 1000 * 60 * 10);
		}, [dispatch]
	);

	return (
		<>
			<IntlProvider locale={localeIntl} messages={language[localeIntl]}>
				<AppContext.Provider value={sessionContext}>
					<Suspense fallback={SuspenseLoading}>
						{apiInflight > 0 ?
							<SusLoading />
							: null}
						<StyledHeader
							open={open}

						>
							<Header
								open={open}
								isMenuOpen={isMenuOpen}
							/>
						</StyledHeader>
						<Drawer
							open={open}
							variant="persistent"
							sx={{
								width: drawerWidth,
								flexShrink: 0,
								'& .MuiDrawer-paper': {
									width: drawerWidth,
									boxSizing: 'border-box'
								}
							}}
						>
							<div className={styles.menuContent}>
								<DrawerHeader>
									<IconButton onClick={toggleDrawer(false)}
										aria-label={language[localeIntl].Collapse_Menu}>
										<ChevronLeftIcon />
									</IconButton>
								</DrawerHeader>
								<Button
									href={headerData.menu.primary[0].to}
									elementType="button"
									secondary={false}
									tertiary
									textMap={{
										newWindow: 'Opens in a new window'
									}}
									onClick={navToPib}
								>
									<FormattedHTMLMessage id="Internet_banking"/>
								</Button>
							</div>
						</Drawer>
						<Main component="main" sx={{ flexGrow: 1, p: 3 }} open={open} arial-hidden={true}>
							<Router history={history}>
								<Route path="/" component={Loader} />
							</Router>
						</Main>
						<footer>
							<div className={styles.controller}>
								<FormattedHTMLMessage id="footer_copyright" values={{ endYear: (new Date()).getFullYear() }} />
								<Paragraph marginBottom={3}>
									<FormattedHTMLMessage id="design_for_hk" />
									<FormattedHTMLMessage id="cross_border" aria-label='open in a new window' />
									<span aria-label='opens in a new window' aria-readonly='true'></span>
								</Paragraph>
							</div>
						</footer>
					</Suspense>
				</AppContext.Provider>
			</IntlProvider>
		</>
	);
}

export default function Controller() {
	return (
		<React.Fragment>
			<Provider store={store}>
				<IntlControllor />
			</Provider>
		</React.Fragment>
	);
}
